import mainline from './mainline';
import firstRunInput from './firstRunInput';
import resultsWorkspace from './resultsWorkspace';
import workflow from './workflow';
import core from './core';
import details from './details';
import firstRun from './firstRun';

const drbfm = {
  mainline,
  firstRun,
  firstRunInput,
  resultsWorkspace,
  workflow,
  ...core,
  ...details,
};

export default drbfm;
